/**
 * Een volgnummer per verzoek, zodat een antwoord van een ouder verzoek genegeerd wordt. Optioneel met
 * een sleutel (bijv. de getypte code): het antwoord telt dan alleen als ook die nog dezelfde is.
 *
 * - `start(key)`: een nieuw verzoek; geeft het volgnummer terug.
 * - `setKey(key)`: de invoer is veranderd (getypt); een lopend verzoek telt niet meer.
 * - `invalidate()`: alles wat nog loopt telt niet meer (bijv. toestemming ingetrokken, unmount).
 * - `isLatest(ticket, key)`: hoort dit antwoord nog bij het laatste verzoek en de huidige invoer?
 */
export function latestRequest<K = undefined>() {
  let seq = 0
  let current: K | undefined
  return {
    start(key?: K): number {
      seq += 1
      current = key
      return seq
    },
    setKey(key: K) {
      if (key === current) return
      seq += 1
      current = key
    },
    invalidate() {
      seq += 1
    },
    isLatest(ticket: number, key?: K): boolean {
      return ticket === seq && key === current
    },
  }
}

export type LatestRequest<K = undefined> = ReturnType<typeof latestRequest<K>>
